import { render, staticRenderFns } from "./EditCompanyProduct.vue?vue&type=template&id=9571dc58"
import script from "./EditCompanyProduct.vue?vue&type=script&lang=js"
export * from "./EditCompanyProduct.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./EditCompanyProduct.vue?vue&type=style&index=0&id=9571dc58&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports